import { getPublishTypeLabel } from './getPublishTypeLabel';

export default getPublishTypeLabel;
